import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  DRUG_FEATURE_KEY,
  State,
  DrugPartialState,
  drugAdapter
} from './drug.reducer';

// Lookup the 'Drug' feature state managed by NgRx
export const getDrugState = createFeatureSelector<DrugPartialState, State>(
  DRUG_FEATURE_KEY
);

const { selectAll, selectEntities } = drugAdapter.getSelectors();

export const getDrugLoading = createSelector(
  getDrugState,
  (state: State) => state.loading
);

export const getDrugSaving = createSelector(
  getDrugState,
  (state: State) => state.saving
);

export const getDrugError = createSelector(
  getDrugState,
  (state: State) => state.error
);

export const getAllDrug = createSelector(getDrugState, (state: State) =>
  selectAll(state)
);

export const getDrugEntities = createSelector(getDrugState, (state: State) =>
  selectEntities(state)
);

export const getSelectedId = createSelector(
  getDrugState,
  (state: State) => state.selectedId
);

export const getSelected = createSelector(
  getDrugEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getDrugDetail = createSelector(
  getDrugState,
  (state: State) => state.drugDetail
);

export const getDrugDetailLoading = createSelector(
  getDrugState,
  (state: State) => state.drugDetailLoading
);

export const getDrugDetailError = createSelector(
  getDrugState,
  (state: State) => state.drugDetailError
);
